import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useQueryParamValue } from 'src/app/shared/hooks/location';

import { useOpenVideoModal } from './useOpenVideoModal';

type Result = ModelHookResult<
	{ shouldShowVideoOnLoad: boolean },
	{ handleButtonClick: () => Promise<void>; showVideo: () => void }
>;

export function useHeroVideoButton(): Result {
	const track = useTracking();
	const ov = useQueryParamValue('ov');
	const openVideoModal = useOpenVideoModal();

	const handleButtonClick = useCallback(async () => {
		if (ov !== 'true') {
			void track('about_impact_video_manual_click');
		}
		await openVideoModal({}).waitForResult();
	}, [track, openVideoModal, ov]);

	const showVideo = useCallback(() => {
		openVideoModal({});
	}, [openVideoModal]);

	return {
		data: { shouldShowVideoOnLoad: ov === 'true' },
		actions: { handleButtonClick, showVideo },
	};
}
